import './index.css'

const AppItem = props => {
  const {eachItem} = props
  const {appId, appName, imageUrl} = eachItem
  return (
    <li key={appId} className="appItem">
      <img className="imageApp" src={imageUrl} alt={appName} />
      <p>{appName}</p>
    </li>
  )
}

export default AppItem
